export { default as BuscarApoderado } from './BuscarApoderado';
export { default as DeudoresCuotas } from './Deudores/componentes/DeudoresCuotas';
export { default as FichaDeApoderado } from './FichaDeApoderado';
export { default as Informes } from './Informes';
export { default as Gastos } from './Gastos';



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/index.ts